import { JoyField, isString } from 'joy-core';
export default class ACClientData {
    /**
     * Create a new ACClientData object.
     * @param data A map of JoyField/value pairs that define the object properties.
     */
    constructor(data) {
        if (!isString(data[JoyField.firstName])) {
            return null;
        }
        this.firstName = data[JoyField.firstName];
        if (!isString(data[JoyField.lastName])) {
            return null;
        }
        this.lastName = data[JoyField.lastName];
        if (!isString(data[JoyField.email])) {
            return null;
        }
        this.email = data[JoyField.email];
    }
}
//# sourceMappingURL=ACClientData.js.map